"use client";

import { SafeErrorBoundary } from "@/components/SafeErrorBoundary";
import { TanstackProvider } from "@/components/providers/tanstack-provider";
import { Toaster } from "@/components/ui/toaster";
import { UnsavedChangesProvider } from "@/app/contexts/UnsavedChangesContext";
import { NavigationGuard } from "@/app/components/ui/NavigationGuard";
import { UnsavedChangesDialog } from "@/app/components/UnsavedChangesDialog";
import { ImpersonationBanner } from "@/app/components/impersonation/impersonation-banner";
import { CrossTabSessionSync } from "@/components/providers/cross-tab-session-sync";
import { useEffect, useState } from "react";
import { migrateClientSessionToLocalStorageIfNeeded } from "@/app/services/utils";

interface ClientAppProps {
  children: React.ReactNode;
}

export function ClientApp({ children }: ClientAppProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    migrateClientSessionToLocalStorageIfNeeded();
    setIsMounted(true);
  }, []);

  // Don't render anything until after mount
  // This ensures we're definitely on the client side
  if (!isMounted) {
    return null;
  }

  return (
    <TanstackProvider>
      <div style={{ maxHeight: "100vh" }}>
        <SafeErrorBoundary>
          <UnsavedChangesProvider>
            <CrossTabSessionSync />
            <ImpersonationBanner />
            <NavigationGuard />
            {/* <AuthGuard> */}
            {children}
            {/* </AuthGuard> */}
            <UnsavedChangesDialog />
          </UnsavedChangesProvider>
        </SafeErrorBoundary>
        <Toaster />
      </div>
    </TanstackProvider>
  );
}
